export const variant = {
  hidden: {
    opacity: 0,
  },
  visible: {
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
    opacity: 1,
  },
};
